/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  current search module constants
 */

export const HAS_MORE_LISTABLES = '@@nzr/currentSearch/HAS_MORE_LISTABLES'
export const NO_MORE_LISTABLES = '@@nzr/currentSearch/NO_MORE_LISTABLES'
export const RECEIVE_CATEGORY_LISTABLES = '@@nzr/currentSearch/RECEIVE_CATEGORY_LISTABLES'
export const RECEIVE_PAGINATED_IDS = '@@nzr/currentSearch/RECEIVE_PAGINATED_IDS'
export const SET_FIRST_PAGE_ADDITIONAL_COUNT = '@@nzr/currentSearch/SET_FIRST_PAGE_ADDITIONAL_COUNT'
export const SET_FIRST_PAGE_COUNT = '@@nzr/currentSearch/SET_FIRST_PAGE_COUNT'
export const SET_FIRST_PAGE_OFFSET = '@@nzr/currentSearch/SET_FIRST_PAGE_OFFSET'
export const SET_FROM_PAID_MARKETING = '@@nzr/currentSearch/SET_FROM_PAID_MARKETING'
export const SET_IS_CATEGORIES_LOADING = '@@nzr/currentSearch/SET_IS_CATEGORIES_LOADING'
export const SET_IS_SEARCH_QUESTIONS_OPEN = '@@nzr/currentSearch/SET_IS_SEARCH_QUESTIONS_OPEN'
export const UPDATE_ADDITIONAL_BUILDING_DATA = '@@nzr/currentSearch/UPDATE_ADDITIONAL_BUILDING_DATA'
export const SET_IS_NAVBAR_EXPANDED = '@@nzr/currentSearch/SET_IS_NAVBAR_EXPANDED'
export const SET_LAST_CLICKED_ENTITY = '@@nzr/currentSearch/SET_LAST_CLICKED_ENTITY'

/** CURRENT SEARCH ROUTE VARS */
export const SET_ROUTE_PATHNAME = '@@nzr/currentSearch/SET_ROUTE_PATHNAME'
export const SET_ROUTE_SEARCHSTRING = '@@nzr/currentSearch/SET_ROUTE_SEARCHSTRING'

/** SEO CONTENT CITY */
export const RECEIVE_CITY_GUIDE_CITY_DATA = '@@nzr/currentSearch/RECEIVE_CITY_GUIDE_CITY_DATA'
export const ERROR_FETCHING_CITY_GUIDE_CITY_DATA =
  '@@nzr/currentSearch/ERROR_FETCHING_CITY_GUIDE_CITY_DATA'
export const START_FETCHING_CITY_GUIDE_CITY_DATA =
  '@@nzr/currentSearch/START_FETCHING_CITY_GUIDE_CITY_DATA'
export const CLEAR_CITY_GUIDE_CITY_DATA = '@@nzr/currentSearch/CLEAR_CITY_GUIDE_CITY_DATA'

/** SEO CONTENT NEIGHBORHOOD */
export const RECEIVE_CITY_GUIDE_NEIGHBORHOOD_DATA =
  '@@nzr/currentSearch/RECEIVE_CITY_GUIDE_NEIGHBORHOOD_DATA'
export const ERROR_FETCHING_CITY_GUIDE_NEIGHBORHOOD_DATA =
  '@@nzr/currentSearch/ERROR_FETCHING_CITY_GUIDE_NEIGHBORHOOD_DATA'
export const START_FETCHING_CITY_GUIDE_NEIGHBORHOOD_DATA =
  '@@nzr/currentSearch/START_FETCHING_CITY_GUIDE_NEIGHBORHOOD_DATA'
export const CLEAR_CITY_GUIDE_NEIGHBORHOOD_DATA =
  '@@nzr/currentSearch/CLEAR_CITY_GUIDE_NEIGHBORHOOD_DATA'
